import { Injectable } from '@angular/core';
import { Firestore, collection, query, where, getDocs } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { IBasicUser, IUser } from '../../../shared/models/users/user.model';
import { UserTypes } from '../../../shared/models/users/constants/user-types';


@Injectable({
  providedIn: 'root'
})
export class CompanyCountService {


   private readonly collectionName = 'companies';



  constructor(private firestore: Firestore) { }

   getCompanyCount(): Observable<number> {
      const companiesCollection = collection(this.firestore, this.collectionName);

      return from(getDocs(companiesCollection)).pipe(
          map(snapshot => snapshot.size)
      );
  }
}
